import { VerticalStack } from '@/components/utils/linearLayouts';
import WarningRounded from '@mui/icons-material/WarningRounded';
import { Tooltip } from '@mui/material';

export const WarningsIcon = ({ warnings = [] }: { warnings?: { message: string }[] }) => {
    const warningStack =
        warnings.length > 0 ? (
            <VerticalStack>{warnings.map((warning) => warning.message)}</VerticalStack>
        ) : null;
    return warnings.length > 0 ? (
        <Tooltip title={warningStack}>
            <WarningRounded color='warning' />
        </Tooltip>
    ) : null;
};
